// Import de funcions auxiliars
import {
    obteVariable,
    obteValorVariable,
    afegeixErrorAVariable
}  from './utils';

/*
 * Per facilitar la lectura del codi s'afegeixen els identificadors de variables a mode de constants
 ***/
export const ID_METEORS_DE_PRECIPITACIO_OBSERVATS = 40;
export const ID_GRUIX_DE_NEU_AL_TERRA = 41;
export const ID_DIAMETRE_DE_LA_PEDRA = 42;
export const ID_ALTRES_METEORS_OBSERVATS = 43;
export const ID_VISIBILITAT = 49;

/*
 * Objectes auxiliars amb les llistes dels possibles valors seleccionables a les variables de:
 *  - Meteors de precipitació
 *  - Altres meteors
 *  - Visiblitat
 ***/
export const meteorNeuSobreTerra = {
    nom: 'Neu sobre el terra (Nt)',
    valor: '47'
};

export const meteorPedra = {
    nom: 'Pedra (Pd)',
    valor: '42'
};

export const meteorBoirina = {
    nom: 'Boirina (Br)',
    valor: '51'
};

export const meteorBoira = {
    nom: 'Boira (Bo)',
    valor: '52'
};

export const meteorCalitja = {
    nom: 'Calitja (Ca)',
    valor: '53'
};

export const visibilitatRegular = {
    nom: 'Regular (1 a 10 km)',
    valor: '94'
};

export const visibilitatDolenta = {
    nom: 'Dolenta (< 1 km)',
    valor: '95'
};

export const visibilitatMoltDolenta = {
    nom: 'Molt dolenta (< 0\'5 km)',
    valor: '96'
};


/*
 * Noms dels diferents valors de cadascuna de les llistes desplegables que s'utilitzaran
 ***/
export const NOM_GRUIX_DE_NEU_AL_TERRA = 'Gruix de neu al terra';
export const NOM_DIAMETRE_DE_LA_PEDRA = 'Diàmetre de la pedra';

/*
 * Missatges d'error propis del grup
 ***/
export const MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU = `Si se selecciona el meteor de precipitació "${meteorNeuSobreTerra.nom}" al grup "Temps present", cal informar la variable "${NOM_GRUIX_DE_NEU_AL_TERRA}" al grup "Neu".`;
export const MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA = `Si s'informa la variable "${NOM_GRUIX_DE_NEU_AL_TERRA}" al grup "Neu", cal informar el meteor de precipitació "${meteorNeuSobreTerra.nom}" al grup "Temps present".`;
export const MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA = `Si se selecciona el meteor de precipitació "${meteorPedra.nom}", cal informar la variable "${NOM_DIAMETRE_DE_LA_PEDRA}".`;
export const MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA = `Si s'informa la variable "${NOM_DIAMETRE_DE_LA_PEDRA}", cal informar el meteor de precipitació "${meteorPedra.nom}".`;
export const MSG_SI_BOIRA_ALESHORES_VISIBILITAT_DOLENTA_O_MOLT_DOLENTA = `Si se selecciona el meteor "${meteorBoira.nom}" al grup "Temps present", al grup "Visibilitat" s'ha d'informar "${visibilitatDolenta.nom}" o "${visibilitatMoltDolenta.nom}".`;
export const MSG_SI_BOIRINA_O_CALITJA_ALESHORES_VISIBILITAT_REGULAR = `Si se selecciona el meteor "${meteorBoirina.nom}" o "${meteorCalitja.nom}" al grup "Temps present", al grup "Visibilitat" s'ha d'informar "${visibilitatRegular.nom}".`;
export const MSG_SI_VISIBILITAT_DOLENTA_O_MOLT_DOLENTA_ALESHORES_BOIRA = `Si s'ha informat "${visibilitatDolenta.nom}" o "${visibilitatMoltDolenta.nom}" al grup "Visibilitat", cal informar el meteor "${meteorBoira.nom}" al grup "Temps present".`;
export const MSG_SI_VISIBILITAT_REGULAR_ALESHORES_BOIRINA_O_CALITJA = `Si s'ha informat "${visibilitatRegular.nom}" al grup "Visibilitat" , cal informar el meteor "${meteorBoirina.nom}" o "${meteorCalitja.nom}" al grup "Temps present".`;

/*
 * Funcions que avaluen si es compleix la condició per afegir l'error
 ***/
const checkSiNeuSobreTerraAleshoresGruixDeNeu = (meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor) => {
    const neuSobreTerraEstaSeleccionat = Array.isArray(meteorsDePrecipitacioObservatsValor) && meteorsDePrecipitacioObservatsValor.indexOf(meteorNeuSobreTerra.valor) >= 0;
    return neuSobreTerraEstaSeleccionat && !gruixDeNeuAlTerraValor;
};

const checkSiGruixDeNeuAleshoresNeuSobreTerra = (meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor) => {
    const neuSobreTerraEstaSeleccionat = Array.isArray(meteorsDePrecipitacioObservatsValor) && meteorsDePrecipitacioObservatsValor.indexOf(meteorNeuSobreTerra.valor) >= 0;
    return !neuSobreTerraEstaSeleccionat && gruixDeNeuAlTerraValor;
};

const checkSiPedraAleshoresDiametreDePedra = (meteorsDePrecipitacioObservatsValor, diametrePedraValor) => {
    const pedraEstaSeleccionat = Array.isArray(meteorsDePrecipitacioObservatsValor) && meteorsDePrecipitacioObservatsValor.indexOf(meteorPedra.valor) >= 0;
    const diametrePedraInformat = diametrePedraValor === 0 || diametrePedraValor;
    return pedraEstaSeleccionat && !diametrePedraInformat;
};
const checkSiDiametreDePedraAleshoresPedra = (meteorsDePrecipitacioObservatsValor, diametrePedraValor) => {
    const pedraEstaSeleccionat = Array.isArray(meteorsDePrecipitacioObservatsValor) && meteorsDePrecipitacioObservatsValor.indexOf(meteorPedra.valor) >= 0;
    const diametrePedraInformat = diametrePedraValor === 0 || diametrePedraValor;
    return !pedraEstaSeleccionat && diametrePedraInformat;
};

/*
 * Grup Temps present i visibilitat
 ***/
export const checkGrupsTempsPresentIVisibilitatINeu = (nouVariables) => {

    // Variables
    const meteorsDePrecipitacioObservats = obteVariable(ID_METEORS_DE_PRECIPITACIO_OBSERVATS, nouVariables);
    const gruixDeNeuAlTerra = obteVariable(ID_GRUIX_DE_NEU_AL_TERRA, nouVariables);
    const diametreDeLaPedra = obteVariable(ID_DIAMETRE_DE_LA_PEDRA, nouVariables);

    // Valors de variables
    const meteorsDePrecipitacioObservatsValor = obteValorVariable(meteorsDePrecipitacioObservats);
    const gruixDeNeuAlTerraValor = obteValorVariable(gruixDeNeuAlTerra);
    const diametreDeLaPedraValor = obteValorVariable(diametreDeLaPedra);

    if (gruixDeNeuAlTerra && meteorsDePrecipitacioObservats) {

        //Si se selecciona el meteor de precipitació "Neu sobre terra (Nt)" al grup "Temps present", cal informar la variable "Gruix de neu al terra" al grup "Neu".
        if (checkSiNeuSobreTerraAleshoresGruixDeNeu(meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor)) {
            afegeixErrorAVariable(gruixDeNeuAlTerra, MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU);
            afegeixErrorAVariable(meteorsDePrecipitacioObservats, MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU);
        }

        //Si s'informa la variable "Gruix de neu al terra" al grup "Neu", cal informar el meteor de precipitació "Neu sobre terra (Nt)" al grup "Temps present".`;
        if (checkSiGruixDeNeuAleshoresNeuSobreTerra(meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor, meteorNeuSobreTerra.valor)) {
            afegeixErrorAVariable(gruixDeNeuAlTerra, MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA);
            afegeixErrorAVariable(meteorsDePrecipitacioObservats, MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA);
        }
    }

    if (diametreDeLaPedra && meteorsDePrecipitacioObservats) {

        //Si se selecciona el meteor de precipitació "Pedra (Pd)", cal informar la variable "Diàmetre de la pedra"
        if (checkSiPedraAleshoresDiametreDePedra(meteorsDePrecipitacioObservatsValor, diametreDeLaPedraValor)) {
            afegeixErrorAVariable(diametreDeLaPedra, MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA);
            afegeixErrorAVariable(meteorsDePrecipitacioObservats, MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA);
        }

        //Si s'informa la variable "Diàmetre de la pedra", cal informar el meteor de precipitació "Pedra (Pd)"
        if (checkSiDiametreDePedraAleshoresPedra(meteorsDePrecipitacioObservatsValor, diametreDeLaPedraValor)) {
            afegeixErrorAVariable(diametreDeLaPedra, MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA);
            afegeixErrorAVariable(meteorsDePrecipitacioObservats, MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA);
        }
    }

};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/grupsTempsPresentIVisibilitatINeu.js